// Copyright (c) 2025 TrustCloud Corporation - All rights reserved.
//
// This software contains valuable confidential and proprietary information of
// TrustCloud Corporation
//
// Unauthorized use, reproduction, transmission, or distribution of this file and its
// contents is a violation of applicable law.

import React, { useState } from 'react';
import { useCurrentRoute } from 'react-navi';
import { Typography } from '@kintent/glide';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';

import { DOCUMENT_TYPE } from 'lib/constants';
import * as Styles from './DocumentDetail.styles';
import { Helmet } from '../../../../../components/Helmet';
import { useArtifactForPDFViewer } from '../../../../../lib/state';

pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/scripts/pdf.worker.min.js`;

// Constants
const DEFAULT_PAGE_HEIGHT = 700;
const DEFAULT_PAGE_WIDTH = 900;

function DocumentDetail() {
  const { data, url } = useCurrentRoute();

  const [totalPages, setTotalPages] = useState(0);

  const { blob, artifact } = useArtifactForPDFViewer(url.query.type, data.slug);

  const handleDocumentLoadSuccess = ({ numPages }) => {
    setTotalPages(numPages);
  };

  /**
   * This handles the one-off case for ServiceNow where the want a document, attached to a notification
   * to be displayed in the file viewer but not in the document list view.
   * The logic below also fixes a crash on the page based on the use-case above.
   */
  const documentTitle = url.query.type === DOCUMENT_TYPE.POLICY ? artifact.title : artifact?.displayName;

  return (
    <>
      <Helmet pageTitle="Documents" />
      <Styles.MainGrid data-testid="document-detail-grid">
        <Styles.DocumentDetailContainer>
          {documentTitle && (
            <Typography
              as="h1"
              level="1"
              className="document-detail-title"
            >
              {documentTitle}
            </Typography>
          )}
          <Styles.PdfWrapper>
            <Document
              file={blob}
              loading=""
              onLoadSuccess={handleDocumentLoadSuccess}
            >
              {Array.from({ length: totalPages }, (_, index) => (
                <Page
                  key={`page_${index + 1}`}
                  height={DEFAULT_PAGE_HEIGHT}
                  width={DEFAULT_PAGE_WIDTH}
                  pageNumber={index + 1}
                  className="page"
                />
              ))}
            </Document>
          </Styles.PdfWrapper>
        </Styles.DocumentDetailContainer>
      </Styles.MainGrid>
    </>
  );
}

export default DocumentDetail;
